import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submit-dialoge',
  templateUrl: './submit-dialoge.component.html',
  styleUrl: './submit-dialoge.component.css'
})
export class SubmitDialogeComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string, title: string, action: string, showCancelButton: boolean, showSuccess: boolean,showOkButton:boolean,showAlert:boolean,showYesButton: boolean,showYesInvButton:boolean, redirectTo:boolean},private router: Router,public dialogRef: MatDialogRef<SubmitDialogeComponent>) {

  }
  onYes(): void {
    this.dialogRef.close(true);   
    if (this.data.action === 'Inventory Error') {
      this.router.navigate(['/create-hot-call']);
    } 
    // else {
    //   this.router.navigate(['/home']);
    // }
  }

  onNo(): void {
    this.dialogRef.close(false);
  }
  onSubmitHotCall(): void {
    this.dialogRef.close(true);
    this.router.navigate([this.data.redirectTo ||'/home']);
  }
}
